import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';
import SectionContainer from '../SectionContainer';
import Field, { hasDataInFields } from '../../Field';
import { AspectRatioWrapper } from '../../../../components';
import { withViewport } from '../../../../util/uiHelpers';

import css from './SectionHowItWorksForTutor.module.css';
import img from './images/how-it-works.png';
import imgMobile from './images/how-it-works-mobile.png';
const MAX_MOBILE_SCREEN_WIDTH = 768;

const SectionHowItWorksForTutor = props => {
  const {
    sectionId,
    className,
    rootClassName,
    defaultClasses,
    numColumns,
    title,
    description,
    appearance,
    callToAction,
    blocks,
    isInsideContainer,
    options,
    intl,
    viewport,
  } = props;

  // If external mapping has been included for fields
  // E.g. { h1: { component: MyAwesomeHeader } }
  const fieldComponents = options?.fieldComponents;
  const fieldOptions = { fieldComponents };

  const hasHeaderFields = hasDataInFields([title, description, callToAction], fieldOptions);
  const isMobileLayout = viewport?.width <= MAX_MOBILE_SCREEN_WIDTH;
  const aspectWidth = isMobileLayout ? 2.5 : 3;
  const aspectHeight = isMobileLayout ? 4 : 4;
  return (
    <SectionContainer
      id={sectionId}
      className={classNames(className)}
      rootClassName={rootClassName}
      appearance={appearance}
      options={fieldOptions}
    >
      <div className={css.container}>
        <div className={css.left}>
          {hasHeaderFields ? (
            <header className={classNames(css.header, defaultClasses.sectionDetails)}>
              <Field data={title} className={defaultClasses.title} options={fieldOptions} />
              <Field
                data={description}
                className={defaultClasses.description}
                options={fieldOptions}
              />
            </header>
          ) : null}

          <div className={css.blocksWrapper}>
            <div className={css.block}>
              <div className={css.blockNumber}>{'01'}</div>
              <div>
                <div className={css.blockTitle}>
                  {intl.formatMessage({
                    id: 'LandingPage.SectionHowItWorksForTutor.1.title',
                  })}
                </div>
                <div className={css.blockDetail}>
                  {intl.formatMessage({
                    id: 'LandingPage.SectionHowItWorksForTutor.1.details',
                  })}
                </div>
              </div>
            </div>
            <div className={css.block}>
              <div className={css.blockNumber}>{'02'}</div>
              <div>
                <div className={css.blockTitle}>
                  {intl.formatMessage({
                    id: 'LandingPage.SectionHowItWorksForTutor.2.title',
                  })}
                </div>
                <div className={css.blockDetail}>
                  {intl.formatMessage({
                    id: 'LandingPage.SectionHowItWorksForTutor.2.details',
                  })}
                </div>
              </div>
            </div>
            <div className={css.block}>
              <div className={css.blockNumber}>{'03'}</div>
              <div>
                <div className={css.blockTitle}>
                  {intl.formatMessage({
                    id: 'LandingPage.SectionHowItWorksForTutor.3.title',
                  })}
                </div>
                <div className={css.blockDetail}>
                  {intl.formatMessage({
                    id: 'LandingPage.SectionHowItWorksForTutor.3.details',
                  })}
                </div>
              </div>
            </div>
          </div>
          <Field
            data={callToAction}
            className={classNames(css.cta, defaultClasses.ctaButton)}
            options={fieldOptions}
          />
        </div>
        <div className={css.right}>
          <AspectRatioWrapper
            className={css.aspectRatioWrapper}
            width={aspectWidth}
            height={aspectHeight}
          >
            <img
              className={css.rootForImage}
              alt="how-it-works"
              src={isMobileLayout ? imgMobile : img}
            />
          </AspectRatioWrapper>
        </div>
      </div>
    </SectionContainer>
  );
};

SectionHowItWorksForTutor.defaultProps = {
  className: null,
  rootClassName: null,
};

SectionHowItWorksForTutor.propTypes = {
  sectionId: string.isRequired,
  className: string,
  rootClassName: string,
};

export default withViewport(SectionHowItWorksForTutor);
